<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="120"
    viewBox="0 0 32 32"
  >
    <circle
      fill="#ffffff"
      :stroke="color.border"
      r="15.25"
      cx="15.95"
      cy="15.95"
      stroke-width="1.25"
    />
    <g
      :fill="color.bec"
      transform="matrix(.03751 0 0 .03751 5.5 4.96)"
    >
      <circle
        cx="515.92"
        cy="412.86"
        r="26"
      />
      <circle
        cx="499.71"
        cy="484.31"
        r="21"
      />
    </g>
    <path
      :fill="color.bec"
      :d="['M23.73 10.83c-.23.06-.94-.04-.94-.04.2.13.33.49.32.73-.7-.09-.98-.32-',
           '1.62-.66 0 .01.45.52.87.84.8.6 1.5 1.32 1.95 2 .22.33.27.37.29.24.06-.4-',
           '.1-1.81-.75-2.74-.1-.13-.11-.27-.12-.37z'].join('')"
    />
    <path
      :d="['M6.84 5.38c-.22-.01-.33.18-.17.33 7.23 3.42 6.16 6.67 7.1 10.4.24 1 1',
           '.92 8.84 10.75 9.6.35.03.45-.36.1-.45-7.21-1.92-8.95-14.53-3.91-14.99.7-.0',
           '6.91.23 1.44.4a4.5 4.5 0 0 0 1.62.19c.47-.87-.37-1.86-1.08-2.6.77-.49 3.24-',
           '1.03 3.53-1.16.18-.08.09-.36-.07-.4-1.13.08-3.81.3-5.02.75-2.11-1.27-4.87-',
           '.28-6.27 1.9-1.43-2.07-3.45-2.7-8.02-3.97Z'].join('')"
    />
    <circle
      :fill="color.border"
      cx="9.25"
      cy="22.65"
      r="8.25"
    />
    <g
      v-html="icon.svg.replace(
        '<svg ',
        `<svg x='4.5' y='18.1' fill='#ffffff' width='9.5' height='9.5' `)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true,
      default() {
        return {
          border: '#725794',
          bec: '#dd6418',
        };
      },
    },
    icon: {
      type: Object,
      required: true,
      default() {
        return {
          fa: 'fighter-jet',
          svg: '',
        };
      },
    },
  },
};
</script>
